<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">设备列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="设备sn码">
                <el-input size="small" style="height:45px" v-model="formInline.machineId" :disabled="editFlag" placeholder="设备sn码"></el-input>
            </el-form-item>
            <el-form-item label="一级代理商" v-if="activeName == 1">
                <el-select v-model="formInline.bindDistributorId" @change="FirstLevelAgentChange" placeholder="请选择">
                    <el-option
                    v-for="item in FirstLevelAgentOptions"
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级代理商" v-if="formInline.bindDistributorId != '' && activeName == 1">
                <el-select v-model="formInline.secDistributorId" @change="SecondaryAgentChange" placeholder="请选择">
                    <el-option
                    v-for="item in SecondaryAgentOptiens"
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商家" v-if="formInline.secDistributorId != '' && activeName == 1">
                <el-select v-model="formInline.bindStoreId" placeholder="请选择">
                    <el-option
                    v-for="item in BusinessUserOptions"
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
        <div>当前列表查询结果：{{ pageparm.total }}条记录</div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="总入库设备" name="1"></el-tab-pane>
            <el-tab-pane label="替换记录" name="2"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="machineId" label="设备sn码" v-if="activeName == 1"></el-table-column>
            <el-table-column  prop="oldMachineId" label="原设备sn码" v-if="activeName == 2"></el-table-column>
            <el-table-column  prop="nickname" label="入库时间" v-if="activeName == 1">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" label="确认故障时间时间"  v-if="activeName == 2" >
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="newMachineId" label="新设备sn码"   v-if="activeName == 2"></el-table-column>
            <el-table-column  prop="remark" label="备注"  v-if="activeName == 2"></el-table-column>
            <el-table-column  prop="inventoryStatus" label="设备状态" v-if="activeName == 1">
                <template slot-scope="scope">
                    <div v-if="scope.row.inventoryStatus == 0">未出库</div>
                    <div v-if="scope.row.inventoryStatus == 1">已出库</div>
                    <div v-if="scope.row.inventoryStatus == 2">故障</div>
                </template>
            </el-table-column>
            <el-table-column  prop="location" label="当前位置" v-if="activeName == 1"></el-table-column>
            <el-table-column  prop="styleName" label="款式" v-if="activeName == 1"></el-table-column>
            <el-table-column  prop="status" label="开机状态" v-if="activeName == 1">
                <template slot-scope="scope">
                    <div v-if="scope.row.status == 1">在线</div>
                    <div v-else>不在线</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" >
                <template slot-scope="scope">
                <!-- <el-button size="mini" type="text" v-if="activeName == 1" v-preventReClick @click="revokeClick(scope.$index, scope.row)">替换设备</el-button> -->
                <el-button size="mini" type="text" v-if="activeName == 1 && scope.row.inventoryStatus != 2" v-preventReClick @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                <el-button size="mini" type="text" v-if="activeName == 1 && scope.row.inventoryStatus == 2" v-preventReClick @click="restoreClick(scope.$index, scope.row)">恢复</el-button>
                <el-button size="mini" type="text" v-if="activeName == 1 && scope.row.inventoryStatus != 2" v-preventReClick @click="maintenanceClick(scope.$index, scope.row)">维修替换</el-button>
                <el-button size="mini" type="text"  v-if="activeName == 1 && scope.row.inventoryStatus == 1" v-preventReClick @click="modifiedModeClick(scope.$index, scope.row)">修改系统模式权限</el-button>
                <el-button size="mini" type="text"  v-if="activeName == 1 && scope.row.inventoryStatus == 1" v-preventReClick @click="Unbind(scope.row)">解绑</el-button>
                <el-button size="mini" type="text"  v-if="activeName == 1" v-preventReClick @click="editStyle(scope.row)">修改款式</el-button>
                <el-button size="mini" type="text"  v-if="activeName == 1" v-preventReClick @click="advertisement(scope.row)">广告管理</el-button>
                <el-button size="mini" type="text"  v-if="activeName == 1 && scope.row.inventoryStatus == 1" v-preventReClick @click="editAddr(scope.row)">修改设备地址</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-form label-width="200px" :model="addDeviceForm" :rules="rules" ref="addDeviceForm">
                <el-form-item label="设置设备系统管理权限：">
                    <el-radio v-model="systemModeOperator" @input="systemModeInput" label="1">由平台设置</el-radio>
                    <el-radio v-model="systemModeOperator" @input="systemModeInput" label="2">由经销商设置</el-radio>
                </el-form-item>
                <el-form-item label="限制设备只能使用以下系统：" v-if="systemModeOperator == 1">
                    <el-checkbox @change="checkboxChange1" v-model="systemModeRange.systemMode1" label="免费系统" ></el-checkbox>
                    <el-checkbox @change="checkboxChange2" v-model="systemModeRange.systemMode2" label="云控桌台系统" ></el-checkbox>
                    <el-checkbox @change="checkboxChange3" v-model="systemModeRange.systemMode3" label="共享桌台系统" ></el-checkbox>
                    <el-checkbox @change="checkboxChange4" v-model="systemModeRange.systemMode4" label="gamebar模式" ></el-checkbox>
                </el-form-item>
                <el-form-item label="设置设备当前的系统：">
                    <el-radio v-model="systemMode" v-if="systemModeRange.systemMode1 == true" label="1">免费系统</el-radio>
                    <el-radio v-model="systemMode" v-if="systemModeRange.systemMode2 == true" label="2">云控桌台系统</el-radio>
                    <el-radio v-model="systemMode" v-if="systemModeRange.systemMode3 == true" label="3">共享桌台系统</el-radio>
                    <el-radio v-model="systemMode" v-if="systemModeRange.systemMode4 == true" label="4">gamebar模式</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="editFormSubmit()">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="设备详情" :visible.sync="detailsFlag" width="35%" @click="closeDialog">
            <el-descriptions class="margin-top" title="入库信息" :column="2" :size="size">
                <el-descriptions-item label="入库时间">{{ storageOrder.createdAt|timestampToTime}}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{storageOrder.createName}}</el-descriptions-item>
                <el-descriptions-item label="入库单号">{{ storageOrder.id}}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" v-if="saleOrder.price != undefined" title="销售信息" :column="2" :size="size">
                <el-descriptions-item label="销售价格">{{saleOrder.price }}</el-descriptions-item>
                <el-descriptions-item label="销售人">{{saleOrder.createName }}</el-descriptions-item>
                <el-descriptions-item label="销售时间">{{saleOrder.createdAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="采购单号">{{saleOrder.id }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" v-if="machine.inventoryStatus == 1" title="出库信息" :column="2" :size="size">
                <el-descriptions-item label="状态">
                    <div v-if="machine.inventoryStatus == 1">已出库</div>
                    <div v-if="machine.inventoryStatus == 0">未出库</div>
                    <div v-if="machine.inventoryStatus == 2">故障</div>
                </el-descriptions-item>
                <el-descriptions-item label="出库单号">{{outOrder.id}}</el-descriptions-item>
                <el-descriptions-item label="创建出库时间">{{outOrder.createdAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="出库时间">{{outOrder.updatedAt|timestampToTime }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" title="注册信息" :column="2" :size="size">
                <el-descriptions-item label="注册状态">{{machine.bindStoreId == undefined?'未注册':'已注册'}}</el-descriptions-item>
                <el-descriptions-item label="商户">{{ machine.bindStoreName }}</el-descriptions-item>
                <el-descriptions-item label="注册时间" v-if="machine.activatedAt != undefined">{{machine.activatedAt|timestampToTime}}</el-descriptions-item>
                <el-descriptions-item label="注册时间" v-else></el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" title="一级代理商信息" :column="2" :size="size">
                <el-descriptions-item label="绑定经销商">{{machine.bindDistributorName}}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" title="二级代理商信息" :column="2" :size="size">
                <el-descriptions-item label="绑定二级代理商">{{machine.secDistributorName}}</el-descriptions-item>
                <el-descriptions-item label="绑定二级代理商员工">{{ machine.bindStaffName }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" v-if="machine.inventoryStatus == 1" title="系统模式" :column="1" :size="size">
                <el-descriptions-item label="设置设备系统模式管理权限">
                    <el-tag size="small" v-if="machine.systemModeOperator == 1">由平台设置</el-tag>
                    <el-tag size="small" v-else>由代理商设置</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="限制设备只能使用以下系统">
                    <el-tag size="small" v-if="machine.systemModeRangeObject.systemMode1 == true">免费模式</el-tag>
                    <el-tag size="small" v-if="machine.systemModeRangeObject.systemMode2 == true">电控模式</el-tag>
                    <el-tag size="small" v-if="machine.systemModeRangeObject.systemMode3 == true">共享模式</el-tag>
                    <el-tag size="small" v-if="machine.systemModeRangeObject.systemMode4 == true">gamebar模式</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="设置设备当前的系统">
                    <el-tag size="small" v-if="machine.systemMode == 1">免费模式</el-tag>
                    <el-tag size="small" v-if="machine.systemMode == 2">电控模式</el-tag>
                    <el-tag size="small" v-if="machine.systemMode == 3">共享模式</el-tag>
                    <el-tag size="small" v-if="machine.systemMode == 4">gamebar模式</el-tag>
                    
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" title="设备信息" :column="2" :size="size">
                <el-descriptions-item label="sn码">{{ machine.machineId }}</el-descriptions-item>
                <el-descriptions-item label="款式">{{ machine.styleName }}</el-descriptions-item>
                
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" v-if="replaceRecords.length != 0" class="margin-top" title="设备替换记录" :column="2" :size="size">
                <el-descriptions-item label="记录">
                    <el-table size="small" :data="replaceRecords" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                        <el-table-column  prop="oldMachineId" label="原设备sn码" ></el-table-column>
                        <el-table-column  prop="newMachineId" label="新设备sn码" ></el-table-column>
                        <el-table-column  prop="createdAt" label="替换时间" >
                            <template slot-scope="scope">
                                <div>{{scope.row.createdAt|timestampToTime}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column  prop="createdAt" label="操作人">
                            <template slot-scope="scope">
                                <div>{{scope.row.createdAt|timestampToTime}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="撤销入库单" :visible.sync="revokeFlag" width="25%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" class="user-search">
                    <el-form-item label="备注">
                        <el-input size="small" v-model="formInline.name" style="width:250px"  placeholder="备注"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="revokeFlag = false">取消</el-button>
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="revokeSubmit()">保存</el-button>
                </div>
        </el-dialog>

        <el-dialog title="设备替换" :visible.sync="maintenanceFlag" width="25%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" class="user-search" label-width="120px">
                    <el-form-item label="原设备sn码：">
                        <div>{{ this.machineId }}</div>
                    </el-form-item>
                    <el-form-item label="新设备sn码：" required >
                        <el-input size="small" v-model="newEquipmentId" style="width:250px"  placeholder="新设备sn码"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" required>
                        <el-input size="small" v-model="remark" style="width:250px"  placeholder="备注"></el-input>
                    </el-form-item>
                    <el-form-item label=" ">
                        <div>设备替换后，新设备将继承原设备的数据</div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="maintenanceFlag = false">取消</el-button>
                    <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="maintenanceSubmit()">保存</el-button>
                </div>
        </el-dialog>

        <el-dialog title="设备解绑" :visible.sync="unBindFlag" width="25%" >
                <div style="line-height:30px">当前绑定省代：{{UnbindForm.distributorName == undefined?'--':UnbindForm.distributorName}} </div>
                <div style="line-height:30px">
                    当前绑定市代：{{UnbindForm.secDistributorName == undefined?'--':UnbindForm.secDistributorName}} 
                    <span v-if="UnbindForm.secDistributorName != undefined" @click="unBindSubmit(2)">解绑</span>
                </div>
                <div style="line-height:30px">
                    当前绑定商户端名称：{{UnbindForm.storeName == undefined?'--':UnbindForm.storeName}} 
                    <span v-if="UnbindForm.storeName != undefined" @click="unBindSubmit(3)">解绑</span>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="unBindFlag = false">关闭</el-button>
                    <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="revokeSubmit()">保存</el-button> -->
                </div>
        </el-dialog>

        <el-dialog title="修改款式" :visible.sync="editStyleFlag" width="25%" >
            <el-form label-width="120px" :model="addDeviceForm" :rules="rules" ref="addDeviceForm">
                <el-form-item label="款式">
                    <el-select v-model="styleId" @change="styleChange" placeholder="请选择">
                        <el-option
                        v-for="item in styleList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editStyleFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="updateStyleSubmit()">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="广告管理" :visible.sync="advertisementFlag" width="40%" >
            <div>
                <el-switch
                @change="isAdvChange"
                v-model="isAdv"
                active-text="机器配置"
                inactive-text="代理商配置"
                active-color="#13ce66"
                inactive-color="#ff4949">
                </el-switch>
                <el-button size="small" type="primary" style="margin-left:20px"  @click="addBanner">新增</el-button>
            </div>
            <el-table size="small" :data="imgList" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top:20px">
                <el-table-column  prop="file" label="图片" >
                    <template slot-scope="scope" align="center">
                        <el-image
                        style="width: 200px; height: 100px"
                        class="img_inner"
                        :src="scope.row.file"
                        fit="fit"></el-image>
                    </template>
                </el-table-column>
                <el-table-column  prop="orderNum" label="排序" ></el-table-column>
                <el-table-column  prop="isShow" label="状态" >
                    <template slot-scope="scope" align="center">
                        {{scope.row.isShow == 1?'上架':'下架'}}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="delImg(scope.row)">删除</el-button>
                        <el-button size="mini" type="text" @click="editAdvClick(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="advertisementFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <el-dialog title="添加广告" :visible.sync="customerServiceFlag" width="40%" @close="kfCloseDialog">
            <el-form label-width="120px" :model="customerServiceForm" :rules="rules" ref="customerServiceRef">
                <el-form-item label="图片：" prop="file">
                    <el-upload
                        class="upload-demo"
                        :http-request="HandleChange2"
                        :file-list="FileList"
                        :on-exceed="onExceed"
                        :on-remove="handleRemove"
                        :limit="1"
                        style="margin-top:15px"
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="排序：" prop="orderNum">
                    <el-input size="small" v-model="customerServiceForm.orderNum" style="width:230px" placeholder="请输入序号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="kfCloseDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="customerServiceSubmit('customerServiceRef')">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="添加广告" :visible.sync="editAdvFlag" width="40%">
            <el-form label-width="120px" :model="editAdvForm" :rules="rules" ref="editAdvForm">
                <el-form-item label="排序：" prop="orderNum">
                    <el-input size="small" v-model="editAdvForm.orderNum" style="width:230px" placeholder="请输入序号"></el-input>
                </el-form-item>
                <el-form-item label="状态：" prop="isShow">
                    <el-select v-model="editAdvForm.isShow" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editAdvFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="editAdvASubmit('editAdvForm')">保存</el-button>
            </div>
        </el-dialog>



        <el-dialog title="修改地址" :visible.sync="editAddrFlag" width="40%">
            <el-form label-width="120px" :model="editAddrForm" :rules="rules" ref="editAddrForm">
                <el-form-item label="省市：" prop="province">
                    <el-input size="small" v-model="editAddrForm.province" style="width:230px" placeholder="请输入省）"></el-input>
                </el-form-item>
                <el-form-item label="省市：" prop="city">
                    <el-input size="small" v-model="editAddrForm.city" style="width:230px" placeholder="请输入市"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editAddrFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="editAddrSubmit('editAddrForm')">保存</el-button>
            </div>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { loadMachineList , getMachine , updateMachineMode , loadBusinessUserList
    ,replaceMachine , restoreMachine ,loadMachineReplaceList ,storeSelect , machineOtherDetail ,
    machineUnbind , styleList , updateStyle , advList , advAdd , DelAdv ,updateAdv , machineAdv , machineUpdateAddr} from '../../api/userMG'
export default {
    data(){
        return{
            isAdv:false,
            advertisementFlag:false,
            unBindFlag:false,
            FirstLevelAgentOptions:[],
            SecondaryAgentOptiens:[],
            BusinessUserOptions:[],
            outOrder:{},
            saleOrder:{},
            replaceRecords:[],
            systemModeOperator:'',
            systemModeRange:{
                systemMode1:true,
                systemMode2:true,
                systemMode3:true,
            },
            systemMode:'',
            revokeFlag:false,
            addDeviceForm:{
                machineId:''
            },
            storageOrder:{},
            machine:{},
            machineIdList:[],
            id:'',
            bindingFlag:false,
            activeName:"1",
            detailsFlag:false,
            options:[
                {
                value: 1,
                label: '上架'
                }, {
                value: 0,
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
                machineId:'',
                bindDistributorId:'',
                secDistributorId:'',
                bindStoreId:''
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            machineId:'',
            id:'',
            maintenanceFlag:false,
            remark:"",
            newEquipmentId:'',
            UnbindForm:{},
            styleList:[],
            styleName:'',
            styleId:'',
            editStyleFlag:false,
            FileList:[],
            imgList:[],
            customerServiceFlag:false,
            customerServiceForm:{
                orderNum:'',
                machineId:'',
                file:'',
            },
            editAdvForm:{

            },
            editAdvFlag:false,
            rules:{
                file:[
                    { required: true, message: '请上传图片', trigger: 'blur' }
                ],
                province:[
                    { required: true, message: '请输入省', trigger: 'blur' }
                ],
                city:[
                    { required: true, message: '请输入市', trigger: 'blur' }
                ],
                orderNum:[
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    {
                        pattern: /^[0-9]$/,
                        required: true,
                        message: '请输入正确序号',
                        trigger: 'blur'
                    }
                ]
            },
            editAddrFlag:false,
            editAddrForm:{

            }
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        this.storeSelect()
        this.styleQuery()
    },
    methods:{
        editAddrSubmit(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    machineUpdateAddr({
                        machineId:this.editAddrForm.machineId,
                        addr:`${this.editAddrForm.province},${this.editAddrForm.city}`
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('操作成功')
                            this.editAddrFlag = false
                            this.getdata()
                        }
                    })
                } else {
                    return false
                }
            })
        },
        editAddr(row){
            this.editAddrFlag = true
            this.editAddrForm = {
                machineId:row.id,
                province:'',
                city:''
            }
        },
        isAdvChange(e){
            console.log(e)
            machineAdv({
                id:this.customerServiceForm.machineId,
                flag:this.isAdv == true?1:0
            }).then(res=>{
                if(!res.success){
                    this.$message.error(res.message)
                }else {
                    this.getdata()
                }
            })
        },
        editAdvClick(row){
            this.editAdvFlag = true
            this.editAdvForm = JSON.parse(JSON.stringify(row))
        },
        editAdvASubmit(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    updateAdv({
                        id:this.editAdvForm.id,
                        isShow:this.editAdvForm.isShow,
                        orderNum:Number(this.editAdvForm.orderNum),
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('操作成功')
                            this.editAdvFlag = false
                            this.advertisement({machineId:this.customerServiceForm.machineId})
                        }
                    })
                } else {
                    return false
                }
            })
        },
        customerServiceSubmit(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    advAdd({
                        machineId:this.customerServiceForm.machineId,
                        file:this.customerServiceForm.file,
                        orderNum:Number(this.customerServiceForm.orderNum),
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('操作成功')
                            this.customerServiceFlag = false
                            this.customerServiceForm.file = ''
                            this.customerServiceForm.orderNum = ''
                            this.FileList = []
                            this.advertisement({machineId:this.customerServiceForm.machineId})
                        }
                    })
                } else {
                    return false
                }
            })
        },
        delImg(row){
            this.$confirm('是否确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                DelAdv(row.id).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.advertisement({machineId:this.customerServiceForm.machineId})
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.messages
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除！'
                })
            })
        },
        addBanner(){
            this.customerServiceFlag = true
            this.customerServiceForm.file = ''
            this.customerServiceForm.orderNum = ''
            this.FileList = []
        },
        // 上传图片
        HandleChange2(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.customerServiceForm.file = res.data.data
                this.FileList.push({
                    url:res.data.data
                })
            })
        },
        handleRemove(e){
            this.FileList = []
            this.customerServiceForm.file = ''
        },
        advertisement(row){
            advList(row.machineId).then(res=>{
                this.imgList = res.data
                this.advertisementFlag = true
                this.customerServiceForm.machineId = row.machineId
                this.isAdv = row.isAdv == 0?false:true
            })
        },
        updateStyleSubmit(){
            if(this.styleId == ''){
                this.$message.error('请选择款式')
            }else{
                updateStyle({
                    id:this.machineId,
                    styleName:this.styleName,
                    styleId:this.styleId
                }).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('修改成功')
                        this.styleId = ''
                        this.styleName = ''
                        this.editStyleFlag = false
                        this.getdata()
                    }
                })
            }
        },
        styleChange(e){ 
            console.log(e)
            for(let item of this.styleList){
                if(e == item.id){
                    this.styleName = item.name
                }
            }
        },
        styleQuery(){
            styleList().then(res=>{
                this.styleList = res.data
            })
        },
        editStyle(row){
            this.editStyleFlag = true
            this.styleId = row.styleId
            this.styleName = row.styleName
            this.machineId = row.machineId
            console.log(row)
        },
        unBindSubmit(type){
            this.$confirm('确定是否解绑?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                machineUnbind({
                    type:type,
                    id:this.machineId
                }).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('解绑成功')
                        this.Unbind({machineId:this.machineId})
                    }
                })
            }).catch(() => {
                
            })
        },
        Unbind(row){
            machineOtherDetail(row.machineId).then(res=>{
                if(!res.success){
                    this.$message.error(res.message)
                }else {
                    this.UnbindForm = res.data
                    this.machineId = row.machineId
                    this.unBindFlag = true
                }
            })
        },
        SecondaryAgentChange(e){
            if(e == ''){
                this.formInline.bindStoreId = ''
            }else {
                loadBusinessUserList({
                    page:1,
                    pageSize:500,
                    secDistributorId:e
                }).then(res=>{
                    let data = [{
                        nickname:'全部',
                        id:''
                    }]
                    data = data.concat(res.pageInfo.list)
                    this.BusinessUserOptions = data
                })
            }
        },
        FirstLevelAgentChange(e){
            console.log(e)
            if(e == ''){
                this.formInline.secDistributorId = ''
                this.formInline.bindStoreId = ''
            }else {
                storeSelect({
                    pageSize:500,
                    page:1,
                    userType:2,
                    parentId:e
                }).then(res=>{
                    let data = [{
                        nickname:'全部',
                        id:''
                    }]
                    data = data.concat(res.data.dataList)
                    this.SecondaryAgentOptiens = data
                })
            }
        },
        storeSelect(){
            storeSelect({
                pageSize:500,
                page:1,
                userType:1,
            }).then(res=>{
                let data = [{
                    nickname:'全部',
                    id:''
                }]
                data = data.concat(res.data.dataList)
                this.FirstLevelAgentOptions = data
            })
        },
        maintenanceSubmit(){
            if(this.newEquipmentId == ''){
                this.$message.error('请输入新设备sn码')
            }else if(this.remark == ''){
                this.$message.error('请输入备注')
            }else if(this.machineId == this.newEquipmentId){
                this.$message.error('新sn码和原sn码重复，请重新输入')
            }else{
                replaceMachine({
                    oldId:this.id,
                    oldMachineId:this.machineId,
                    newMachineId:this.newEquipmentId,
                    remark:this.remark,
                }).then(res=>{
                    if(res.success){
                        this.$message.success('操作成功')
                        this.newEquipmentId = '',
                        this.remark = ''
                        this.maintenanceFlag  = false
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }
        },  
        maintenanceClick(index , row){
            this.newEquipmentId = ''
            this.remark = ''
            this.machineId = row.machineId
            this.id = row.id
            this.maintenanceFlag = true
        },
        checkboxChange1(e){
            console.log(e)
            if(e == false && this.systemMode == 1){
                this.systemMode = ''
            }
        }, 
        checkboxChange2(e){
            console.log(e)
            if(e == false && this.systemMode == 2){
                this.systemMode = ''
            }
        },  
        checkboxChange3(e){
            console.log(e)
            if(e == false && this.systemMode == 3){
                this.systemMode = ''
            }
        },
        checkboxChange4(e){
            console.log(e)
            if(e == false && this.systemMode == 4){
                this.systemMode = ''
            }
        }, 
        systemModeInput(e){
            if(e == 1){
                this.systemModeRange = {
                    systemMode1:false,
                    systemMode2:false,
                    systemMode3:false,
                }
                this.systemMode = ''
            }else {
                this.systemModeRange = {
                    systemMode1:true,
                    systemMode2:true,
                    systemMode3:true,
                }
            }
        },
        editFormSubmit(){
            if(this.systemModeOperator == ''){
                this.$message.error('请选择设置设备系统管理权限')
            }else if(this.systemModeRange.systemMode1 == false && this.systemModeRange.systemMode2 == false && this.systemModeRange.systemMode3 == false && this.systemModeRange.systemMode4 == false){
                this.$message.error('请选择限制设备只能使用以下系统')
            }else if(this.systemMode == ''){
                this.$message.error('请选择设置设备当前的系统')
            }else {
                updateMachineMode({
                    id:this.machine.id,
                    systemMode:this.systemMode,
                    systemModeOperator:this.systemModeOperator,
                    systemModeRange:JSON.stringify(this.systemModeRange)
                }).then(res=>{
                    if(res.success){
                        this.$message.success('配置生效')
                        this.editFormVisible = false
                        this.systemModeRange = {
                            systemMode1:true,
                            systemMode2:true,
                            systemMode3:true,
                            systemMode4:true,
                        }
                        this.systemMode = ''
                        this.systemModeOperator = ''
                    }else {
                        this.$message.error(res.messages)
                    }
                })
            }
        },
        modifiedModeClick(index , row){
            getMachine({
                id:row.id
            }).then(res=>{
                this.editFormVisible = true
                this.systemMode = res.machine.systemMode.toString()
                this.systemModeOperator = res.machine.systemModeOperator.toString()
                this.systemModeRange = res.machine.systemModeRangeObject
                this.storageOrder = res.storageOrder
                this.machine = res.machine
            })
        },  
        revokeSubmit(){
            
        },  
        revokeClick(index , row){
            this.revokeFlag = true
            this.id = row.id
        },
        addDeviceClick(){
            if(this.addDeviceForm.machineId == ''){
                this.$message.error('设备sn码不能为空')
            }else{
                let pushFlag = false
                for(let item of this.machineIdList){
                    if(item == this.addDeviceForm.machineId){
                        pushFlag = true
                    }
                }
                if(pushFlag == true){
                    this.$message.error('改设备sn码与已添加')
                }else{
                    this.machineIdList.push(this.addDeviceForm.machineId)
                    this.addDeviceForm.machineId = ''
                }
            }
        },
        deleteClick(index){
            this.machineIdList.splice(index , 1)
        },
        restoreClick(index , row){
            this.$confirm('是否确认恢复?', '恢复后，设备状态将由故障变为未出库', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            // 删除
            restoreMachine({id:row.id}).then(res => {
                    if (res.success) {
                        this.$message({
                        type: 'success',
                        message: '解绑成功!'
                        })
                        this.getdata()
                    } else {
                        this.$message({
                        type: 'info',
                        message: res.messages
                        })
                    }
                })
                .catch(err => {
                    this.loading = false
                    this.$message.error('解绑失败，请稍后再试！')
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消恢复！'
                })
            })  
        },  
        handleEdit(index , row){
            getMachine({
                id:row.id
            }).then(res=>{
                if(res.success){
                    this.detailsFlag = true
                    this.storageOrder = res.storageOrder
                    this.machine = res.machine
                    this.replaceRecords = res.replaceRecords
                    this.outOrder = res.outOrder == undefined?{}:res.outOrder
                    this.saleOrder = res.saleOrder == undefined?{}:res.saleOrder
                }else{
                    this.$message.error(res.messages)
                }
                
            })
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.formInline.machineId = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        handleClick(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            if(this.activeName == 1){
                loadMachineList({
                    page:this.formInline.page,
                    pageSize:this.formInline.limit,
                    machineId:this.formInline.machineId,
                    bindDistributorId:this.formInline.bindDistributorId,
                    secDistributorId:this.formInline.secDistributorId,
                    bindStoreId:this.formInline.bindStoreId
                }).then(res=>{
                    this.listData = res.pageInfo.list
                    this.pageparm.total = res.pageInfo.total
                })
            }else {
                loadMachineReplaceList({
                    page:this.formInline.page,
                    pageSize:this.formInline.limit,
                    machineId:this.formInline.machineId
                }).then(res=>{
                    this.listData = res.pageInfo.list
                    this.pageparm.total = res.pageInfo.total
                })
            }
            
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  span{
    color: #409EFF;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/devicesManagement/devicesList.vue